<template>
  <v-app>
    <div class="installment_product_wrapper" v-if="editedItem">
      <v-progress-circular v-show="loading"
                           indeterminate
                           color="primary"
      ></v-progress-circular>


      <div class="page page2" style="height: 1210px;">
        <div class="installment_product_header">
<!--          <table class="leftBox">-->
<!--            <tr>-->
<!--              <th width="100px">超優</th>-->
<!--              <th width="100px">優加</th>-->
<!--              <th width="58px">優質</th>-->
<!--&lt;!&ndash;              <th width="">一般</th>&ndash;&gt;-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td><input type="text"  v-model="editedItem.header.caseType5" @click="showCheckDialog(0)"-->
<!--                         style="width:100%;" :disabled="checkCaseType" readonly></td>-->
<!--              <td><input type="text" placeholder="必填" v-model="editedItem.header.caseType" @click="showCheckDialog(0)"-->
<!--                         style="width:100%;" :disabled="checkCaseType" readonly></td>-->
<!--              &lt;!&ndash;代償變打勾&ndash;&gt;-->
<!--              &lt;!&ndash; <td v-if="editedItem.vendor.productId === '2'"><span class="checkbox"><input type="checkbox" v-model="editedItem.header.type[0].value"></span></td> &ndash;&gt;-->
<!--              <td ><input type="text" style="width:100%;" v-model="editedItem.header.caseType4" :disabled="checkCaseType4" @click="showCheckDialog(1)" readonly></td>-->

<!--&lt;!&ndash;              <td><span class="checkbox"><input type="checkbox" v-model="editedItem.header.type[1].value" :disabled="checkType1" ></span></td>&ndash;&gt;-->
<!--            </tr>-->
<!--          </table>-->

<!--todo 9/23更新-->
          <table class="leftBox" style="z-index: 10;">
            <tr>
              <th width="45px">專案</th>
              <td width="45px">
                <span v-if="editedItem.header.caseType5 !== ''">超優</span>
                <span v-if="editedItem.header.caseType !== ''">優加</span>
                <span v-if="editedItem.header.caseType4 !== ''">優質</span>
              </td>
              <th width="45px">客&nbsp;戶<br/>條&nbsp;件</th>
              <td>
                <input  v-if="editedItem.caseType === '' || editedItem.caseType === 3" type="text"  v-model="editedItem.header.caseType5" @click="showCheckDialog(0)"
                           style="width:100%;"  readonly>
                <input v-if="editedItem.caseType === 1" type="text" placeholder="必填" v-model="editedItem.header.caseType" @click="showCheckDialog(0)"
                           style="width:100%;" readonly>
                <input v-if="editedItem.caseType === 0" type="text" placeholder="必填" v-model="editedItem.header.caseType4" @click="showCheckDialog(0)"
                         style="width:100%;"  readonly>
              </td>
            </tr>
          </table>
          <h1>裕隆集團&nbsp;&nbsp;&nbsp;裕富數位資融股份有限公司<span  class="h1s">2023.08&nbsp;通路版</span></h1>
          <h2>購物分期付款申請暨約定書</h2>
        </div><!--header-->
        <div class="blueBox blueBox1">
          <div class="tit">基本資料</div>
          <div class="date">
            申請日期：
            <select v-model="editedItem.applyDate.year">
              <option v-for="year in yearList" :key="year.key" :value="year.key">{{year.name}}</option>
            </select>年
            <select v-model="editedItem.applyDate.month">
              <option v-for="month in monthList" :key="month.key" :value="month.key">{{month.name}}</option>
            </select>月
            <select v-model="editedItem.applyDate.day">
              <option v-for="day in dayList" :key="day.key" :value="day.key">{{day.name}}</option>
            </select>日
          </div>
          <table class="blueTable blueTable1">
            <tr>
              <th width="45px">中&nbsp;文<br/>姓&nbsp;名</th>
              <td width="113px">
                <input type="text" v-model="editedItem.customer.name" placeholder="1.必填" style="width:100px">
                <!--<img style="width:100px; position: absolute;" :src="editedItem.signImage0" @click="showSignDialog('name')"/>-->
                <!--<input-->
                <!--style="width:100px; z-index: 100; background: transparent;" type="text" @click="showSignDialog('name')"/>-->
              </td>
              <th width="48px">身分證<br/>字&nbsp;&nbsp;&nbsp;&nbsp;號</th>
              <td><input type="text" v-model="editedItem.customer.memberId" placeholder="2.必填" style="width:100px">
                <!--<input type="button" value="拍照"-->
                <!--@click="takePhoto"/>-->
              </td>
            </tr>
            <tr>
              <th>出&nbsp;生<br/>日&nbsp;期</th>
              <td>
                <input type="text" placeholder="3.必填出生日" v-model="editedItem.customer.birthday"
                       v-on:change="changeDateInfo('birthday')"
                       v-on:keyup="changeDateInfo('birthday')"
                       @click="showDateToolDialog('birthday')" style="width:100px"/>
              </td>
              <th>婚&nbsp;姻<br/>狀&nbsp;況</th>
              <td>
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.married[0].value"
                                                                    :checked="editedItem.customer.married[0].value === true"></span>已婚
                </div>
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.married[1].value"
                                                                    :checked="editedItem.customer.married[1].value === true"></span>未婚
                </div>
                <br/>
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.hasChild"
                                                                    :checked="editedItem.customer.hasChild"></span>子女
                  <input type="text" v-model="editedItem.customer.childCount"
                         style="width:25px; line-height:13px; height:13px; text-align:center">人
                </div>
              </td>
            </tr>
          </table><!--blueTable1-->
          <table class="blueTable blueTable2">
            <tr>
              <th width="45px">身分證<br/>初補換</th>
              <td width="163px">
                <div class="checkDiv">
                                    <span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.customer.memberIdType[0].value"
                                                                  :checked="editedItem.customer.memberIdType[0].value === true"></span>初發<br/>
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.memberIdType[1].value"
                                                :checked="editedItem.customer.memberIdType[1].value === true"></span>補發<br/>
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.memberIdType[2].value"
                                                :checked="editedItem.customer.memberIdType[2].value === true"></span>換發
                </div>
                <div class="date2">
                  <input type="text" placeholder="4.必填" v-model="editedItem.customer.memberIdDate"
                         v-on:change="changeDateInfo('memberIdDate')"
                         v-on:keyup="changeDateInfo('memberIdDate')"
                         @click="showDateToolDialog('memberIdDate')" style="width:100px"/>
                  <!--<input type="text" placeholder="必填" v-model="editedItem.customer.memberIdDate" @focus="showDateToolDialog('memberIdDate')" style="width:100px"/>-->
                </div>
              </td>
              <th width="48px">發&nbsp;證<br/>地&nbsp;點</th>
              <!--@click="showCityDialog()"-->
              <td>

                <select v-model="editedItem.customer.memberIdCity" style="text-align:center">
                  <option v-for="type in getMemberIdCityList" :key="type.key" :value="type.key">
                    {{type.value}}
                  </option>
                </select>
                <!-- <input v-else type="text" placeholder="5.必填"
                         v-model="editedItem.customer.memberIdCity" style="width:100px"> -->
              </td>

            </tr>
          </table><!--blueTable2-->
          <table class="blueTable blueTable3">
            <tr>
              <th width="45px">戶&nbsp;籍<br/>電&nbsp;話</th>
              <td width="115px" class="td-phone">
                <div class="checkDiv">
                                <span class="checkbox"><input type="checkbox"
                                                              v-model="editedItem.customer.hasPhone"></span>無
                </div>
                <input type="text" placeholder="6.填寫加分" v-model="editedItem.customer.phone"
                       onKeyUp="value=value.replace(/\D/g,'')"
                       onchange="value=value.replace(/\D/g,'')"
                       maxlength="11"
                       style="width:100px; margin-top:6px;">
              </td>
              <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv">
                                <span class="checkbox"><input type="checkbox"
                                                              v-model="editedItem.customer.hasHomePhone"></span>無
                </div>
                <input type="text" placeholder="7.填寫加分" v-model="editedItem.customer.homePhone"
                       onKeyUp="value=value.replace(/\D/g,'')"
                       onchange="value=value.replace(/\D/g,'')"
                       maxlength="11"
                       style="width:100px; margin-top:6px;">
                <div :class="`btn-s btn-s1 ${editedItem.customer.isSecret ? 'btn-s-active':''}`">
                  <a href="#" target="_self"
                     @click.prevent="editedItem.customer.isSecret = !editedItem.customer.isSecret">保密</a>
                </div>
              </td>
            </tr>
            <tr>
              <th>行&nbsp;動<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv">
                                <span class="checkbox"><input type="checkbox"
                                                              v-model="editedItem.customer.hasCellphone"></span>無
                </div>
                <input type="number" placeholder="8.必填" v-model="editedItem.customer.cellphone"
                       onKeyUp="value=value.replace(/\D/g,'')"
                       onchange="value=value.replace(/\D/g,'')"
                       maxlength="11"
                       style="width:100px; margin-top:6px;">
              </td>
              <th>教&nbsp;育<br/>程&nbsp;度</th>
              <td>
                <div class="checkDiv checkDiv3">
                                <span class="checkbox"><input type="checkbox"
                                                              v-model="editedItem.customer.educationLevel[0].value"></span>博士
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[1].value"></span>碩士
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[2].value"></span>大學
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[3].value"></span>專科
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[4].value"></span>高中職
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.educationLevel[5].value"></span>其他
                </div>
              </td>
            </tr>
            <tr>
              <th>戶&nbsp;籍<br/>地&nbsp;址</th>
              <td colspan="3"><textarea  style="width:50px; height:26px; line-height:12px; padding:0;"
                                         placeholder="郵遞區號"
                                         v-model="editedItem.customer.home.residencePost" type="number"
                                         onKeyUp="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"
                                         onchange="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"/>
                <textarea style="width:50px; height:26px; line-height:12px; padding:0;" placeholder="縣市"
                          v-model="editedItem.customer.home.residenceCity"
                          v-on:change="changeResidenceInfo"
                          v-on:keyup="changeResidenceInfo"
                ></textarea>
                <textarea style="width:50px; height:26px; line-height:12px; padding:0;" placeholder="區鄉鎮"
                          v-model="editedItem.customer.home.residenceArea"
                          v-on:change="changeResidenceInfo"
                          v-on:keyup="changeResidenceInfo"
                ></textarea>
                <textarea style="width:150px; height:26px; line-height:12px; padding:0;" placeholder="地址"
                          v-model="editedItem.customer.home.residenceAddress"
                          onKeyUp="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                          onchange="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>住&nbsp;宅<br/>地&nbsp;址</th>
              <td colspan="3" class="td-address4">
                <div class="checkDiv checkDiv4">
                                <span class="checkbox"><input type="checkbox"
                                                              v-model="editedItem.customer.home.homeType1[0].value"
                                                              @change="checkHomeType"></span>同戶籍
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.homeType1[1].value"></span>另列如下
                </div>
                <textarea  style="width:50px; height:26px; line-height:12px; padding:0;"
                           placeholder="郵遞區號"
                           v-model="editedItem.customer.home.homePost" type="number"  onKeyUp="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"
                           onchange="value=value.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')"/>
                <textarea style="width:50px; height:26px; line-height:12px; padding:0;" placeholder="縣市"
                          v-model="editedItem.customer.home.homeCity"
                          v-on:change="changeHomeInfo"
                          v-on:keyup="changeHomeInfo"
                ></textarea>
                <textarea style="width:50px; height:26px; line-height:12px; padding:0;" placeholder="區鄉鎮"
                          v-model="editedItem.customer.home.homeArea"
                          v-on:change="changeHomeInfo"
                          v-on:keyup="changeHomeInfo"
                ></textarea>
                <textarea style="width:150px; height:26px; line-height:12px; padding:0;" placeholder="地址"
                          v-model="editedItem.customer.home.homeAddress1" onKeyUp="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"
                          onchange="value=value.replace(/([\r\n])|(<\/?. ?>)/g,'')"></textarea>
              </td>
            </tr>
            <tr>
              <th>居&nbsp;住<br/>時&nbsp;間</th>
              <td>
                <div class="date3">
                  <input type="text" v-model="editedItem.customer.home.liveYear"
                         style="width:35px; text-align:center">年
                  <input type="text" v-model="editedItem.customer.home.liveMonth"
                         style="width:35px; text-align:center">月
                </div>
              </td>
              <th>居&nbsp;住<br/>狀&nbsp;況</th>
              <td>
                <div class="checkDiv checkDiv5">
                                <span class="checkbox"><input type="checkbox"
                                                              v-model="editedItem.customer.home.liveLevel[0].value"></span>本人名下
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[1].value"></span>配偶名下<br/>
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[2].value"></span>親友
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[3].value"></span>租賃
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[4].value"></span>宿舍
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.customer.home.liveLevel[5].value"></span>其他
                </div>
              </td>
            </tr>
            <tr>
              <th>繳&nbsp;款<br/>方&nbsp;式</th>
              <td colspan="3" class="td-address6">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.usePhonePayment"></span>簡訊條碼繳款
                </div>
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.useElectronicBill"></span>電子帳單(請填E-mail)
                </div>
                <br/>
                <input type="text" v-model="editedItem.customer.paymentEmail" style="width:267px;">
              </td>
            </tr>
            <tr>
              <th>E-mail</th>
              <td colspan="3" class="td-email">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.customer.hasMail"></span>無
                </div>
                <input type="text" placeholder="11.填寫加分" v-model="editedItem.customer.email" style="width:267px;">
              </td>
            </tr>
          </table><!--blueTable3-->
        </div><!--blueBox1-->
        <div class="blueBox blueBox2">
          <div class="tit">職業資料</div>
          <span>
<!--專案類型-->
            <select v-model="editedItem.vendor.productId" style="text-align:center">
              <option v-for="type in getCaseTypeList" :key="type.key" :value="type.key">
                {{type.value}}
              </option>
            </select>
          </span>
          <div class="contact">
            <!--          服務電話：(02)2702-5055#3<br/>-->
            <!--          案件傳真：(02)2700-3559-->
          </div>
          <table class="blueTable blueTable4">
            <tr>
              <th width="48px">公&nbsp;司<br/>名&nbsp;稱</th>
              <td width="135px" class="td-com">
                <div class="checkDiv">
                                <span class="checkbox"><input type="checkbox"
                                                              v-model="editedItem.company.type[0].value"></span>無<span
                  class="checkbox">
                                    <input type="checkbox" v-model="editedItem.company.type[1].value"></span>家管<span
                  class="checkbox">
                                    <input type="checkbox" v-model="editedItem.company.type[2].value"></span>另列如下
                </div>
                <input type="text" placeholder="12.必填" v-model="editedItem.company.name"
                       style="width:125px; margin-top:6px;">
              </td>
              <th width="48px">公&nbsp;司<br/>電&nbsp;話</th>
              <td class="td-phone">
                <!-- <div class="checkDiv">
                                  <span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.company.hasPhone"></span>無
                </div> -->
                <input type="text" placeholder="區碼" v-model="editedItem.company.areaCode" onKeyUp="value=value.replace(/\D/g,'')"
                       onchange="value=value.replace(/\D/g,'')"
                       maxlength="3" style="width:30px;">
                <input type="text" placeholder="13.必填" v-model="editedItem.company.phone" onKeyUp="value=value.replace(/\D/g,'')"
                       onchange="value=value.replace(/\D/g,'')"
                       maxlength="11" style="width:70px;">
                <div :class="`btn-s btn-s2 ${editedItem.company.isSecret ? 'btn-s-active':''}`">
                  <a href="#" target="_self" @click.prevent="editedItem.company.isSecret = !editedItem.company.isSecret">保密</a>
                </div>
              </td>
            </tr>
            <tr>
              <th>公&nbsp;司<br/>地&nbsp;址</th>
              <td class="td-address" colspan="3">
                <div class="checkDiv">
                                <span class="checkbox"><input type="checkbox"
                                                              v-model="editedItem.company.hasAddress"></span>無
                </div>
                <textarea style="width:300px; height:24px; line-height:12px; padding:0; margin-bottom:-2px;"
                          placeholder="14.填寫加分"
                          v-model="editedItem.company.address"></textarea>
              </td>
            </tr>
          </table><!--blueTable4-->
          <table class="blueTable blueTable5">
            <tr>
              <th width="48px">職稱</th>
              <td width="90px"><input type="text" placeholder="15.填寫加分" v-model="editedItem.company.title"
                                      style="width:80px;"></td>
              <th width="35px">年資</th>
              <td width="73px">
                <div class="date4">
                  <input type="text" v-model="editedItem.company.workYear"
                         style="width:17px; text-align:center; padding:0">年
                  <input type="text" v-model="editedItem.company.workMonth"
                         style="width:17px; text-align:center; padding:0">月
                </div>
              </td>
              <th width="33px">月薪</th>
              <td><input type="text" placeholder="16.填寫加分" v-model="editedItem.company.salary" style="width:60px;">元</td>
            </tr>
          </table><!--blueTable5-->
          <div class="blueBox blueBox3">
            <div class="tit">銀行資料</div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.bank.type[0].value"></span>沒辦過卡
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.bank.type[1].value"></span>無卡自停
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.bank.type[2].value"></span>協商繳款中
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.bank.type[3].value"></span>其他：<input
              type="text" v-model="editedItem.bank.otherType" style="width:55px;"></div>
            <table class="blueTable blueTable6">
              <tr>
                <th width="48px">發&nbsp;卡<br/>銀&nbsp;行</th>
                <td width="125px"><input type="text" placeholder="17.填寫加分" v-model="editedItem.bank.name"
                                         style="width:110px;">
                </td>
                <th width="50px">有&nbsp;效<br/>日&nbsp;期</th>
                <td>
                  <div class="date5">
                    <input type="text" v-model="editedItem.bank.effectiveMonth"
                           style="width:45px; text-align:center">月
                    <input type="text" v-model="editedItem.bank.effectiveYear"
                           style="width:45px; text-align:center">年
                  </div>
                </td>
              </tr>
              <tr>
                <th>卡號</th>
                <td colspan="3" class="cardNb"><input type="text" placeholder="18.填寫加分"
                                                      v-model="editedItem.bank.creditCard"
                                                      style="width:150px; "><span
                  class="ps">(請填寫本人正卡資料)</span></td>
              </tr>
            </table><!--blueTable6-->
          </div><!--blueBox3-->
          <div class="blueBox blueBox4">
            <div class="tit">聯絡人資料</div>
            <span class="titps">(請留一位與您不同居所的親屬，若無住家電話請留兩位聯絡人)</span>
            <table class="blueTable blueTable7">
              <tr>
                <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
                <td width="110px"><input type="text" placeholder="19.必填" v-model="editedItem.firstContact.name"
                                         @click="showTip"
                                         style="width:100px; "></td>
                <th width="30px">關係</th>
                <td width="35px" class="text_c"><input type="text" placeholder="20.必填"
                                                       v-model="editedItem.firstContact.type"
                                                       style="width:30px; "></td>
                <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.firstContact.hasCellphone"></span>無
                  </div>
                  <input type="number" placeholder="21.必填" v-model="editedItem.firstContact.cellphone"
                         onKeyUp="value=value.replace(/\D/g,'')"
                         onchange="value=value.replace(/\D/g,'')"
                         maxlength="11"
                         style="width:80px; margin-bottom:-2px; margin-top:-2px;">
                </td>
              </tr>
            </table><!--blueTable7-->
            <table class="blueTable blueTable8">
              <tr>
                <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                <td width="140px" class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.firstContact.hasHomePhone"></span>無
                  </div>
                  <input type="text" placeholder="22.填寫加分" v-model="editedItem.firstContact.homePhone"
                         style="width:80px; margin-top:6px;">
                </td>
                <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.firstContact.hasCompanyPhone"></span>無
                  </div>
                  <input type="text" placeholder="23.填寫加分" v-model="editedItem.firstContact.companyPhone"
                         style="width:80px; margin-top:6px;">
                  <div :class="`btn-s btn-s3 ${editedItem.firstContact.isSecret ? 'btn-s-active':''}`">
                    <a href="#" target="_self"
                       @click.prevent="editedItem.firstContact.isSecret = !editedItem.firstContact.isSecret">保密</a>
                  </div>
                </td>
              </tr>
            </table><!--blueTable8-->
            <table class="blueTable blueTable9">
              <tr>
                <th width="48px">中&nbsp;文<br/>姓&nbsp;名</th>
                <td width="110px"><input type="text" placeholder="24.必填" v-model="editedItem.secondContact.name"
                                         @click="showSecondTip"
                                         style="width:100px; "></td>
                <th width="30px">關係</th>
                <td width="35px" class="text_c"><input type="text" placeholder="25.必填"
                                                       v-model="editedItem.secondContact.type"
                                                       style="width:30px; "></td>
                <th width="50px">行&nbsp;動<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.secondContact.hasCellphone"></span>無
                  </div>
                  <input type="number" placeholder="26.必填" v-model="editedItem.secondContact.cellphone"
                         onKeyUp="value=value.replace(/\D/g,'')"
                         onchange="value=value.replace(/\D/g,'')"
                         maxlength="11"
                         style="width:80px; margin-bottom:-2px; margin-top:-2px;">
                </td>
              </tr>
            </table><!--blueTable9-->
            <table class="blueTable blueTable10">
              <tr>
                <th width="48px">住&nbsp;宅<br/>電&nbsp;話</th>
                <td width="140px" class="td-phone">
                  <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                      v-model="editedItem.secondContact.hasHomePhone"></span>無
                  </div>
                  <input type="text" placeholder="27.填寫加分" v-model="editedItem.secondContact.homePhone"
                         style="width:80px; margin-top:6px;">
                </td>
                <th width="35px">公&nbsp;司<br/>電&nbsp;話</th>
                <td class="td-phone">
                  <input type="text" placeholder="28.填寫加分" v-model="editedItem.secondContact.companyPhone"
                         style="width:80px;">
                  <div :class="`btn-s btn-s4 ${editedItem.secondContact.isSecret ? 'btn-s-active':''}`">
                    <a href="#" target="_self"
                       @click.prevent="editedItem.secondContact.isSecret = !editedItem.secondContact.isSecret">保密</a>
                  </div>
                </td>
              </tr>
            </table><!--blueTable10-->
          </div><!--blueBox4-->
        </div><!--blueBox2-->
        <div class="redBox">
          <div class="ps" style="width: 835px;">※以下欄位資料為：
            <div class="checkDiv">1.<span class="checkbox">
                        <input type="checkbox" v-model="editedItem.hasJointGuarantor[0].value"></span>連帶保證人(需附保證人身分證正反面影本及簽名)
            </div>
            <div class="checkDiv">2.<span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.hasJointGuarantor[1].value"></span>配偶資料僅供參考
            </div>
            <div class="checkDiv">3.<span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.hasJointGuarantor[2].value"></span>法定代理人(須於法代欄位簽名)
            </div>
            <div class="checkDiv">4.<span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.hasJointGuarantor[3].value"></span>商品實際使用人
            </div>
          </div>
          <table class="redTable">
            <tr>
              <th width="48px">姓&nbsp;名</th>
              <td width="160px"><input type="text" v-model="editedItem.jointGuarantor.name"
                                       style="width:100px; "></td>
              <th width="55px">關&nbsp;係</th>
              <td width="83px"><input type="text" v-model="editedItem.jointGuarantor.type"
                                      style="width:70px; "></td>
              <th width="48px">身分證<br/>字&nbsp;&nbsp;號</th>
              <td width="153px"><input type="text" v-model="editedItem.jointGuarantor.memberId"
                                       style="width:100px; "></td>
              <th width="48px">出&nbsp;生<br/>日&nbsp;期</th>
              <td>
                <div class="date6">
                  <input type="text" v-model="editedItem.jointGuarantor.birthday"
                         v-on:change="changeDateInfo('jointGuarantor.birthday')"
                         v-on:keyup="changeDateInfo('jointGuarantor.birthday')"
                         @click="showDateToolDialog('jointGuarantor.birthday')"
                         style="width:100px; ">
                </div>
              </td>
            </tr>
            <tr>
              <th>身分證<br/>初補換</th>
              <td>
                <div class="checkDiv">
                                <span class="checkbox"><input type="checkbox"
                                                              v-model="editedItem.jointGuarantor.memberIdType[0].value"></span>初發<br/>
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.jointGuarantor.memberIdType[1].value"></span>補發<br/>
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.jointGuarantor.memberIdType[2].value"></span>換發
                </div>
                <div class="date7">
                  <input type="text" v-model="editedItem.jointGuarantor.memberIdDate"
                         v-on:change="changeDateInfo('jointGuarantor.memberIdDate')"
                         v-on:keyup="changeDateInfo('jointGuarantor.memberIdDate')"
                         @click="showDateToolDialog('jointGuarantor.memberIdDate')"
                         style="width:100px; margin-top:-10px;">
                </div>
              </td>
              <th>發&nbsp;證<br/>地&nbsp;點</th>
              <td><input type="text" v-model="editedItem.jointGuarantor.memberIdCity" style="width:70px; ">
              </td>
              <th>住&nbsp;家<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.jointGuarantor.hasHomePhone"></span>無
                </div>
                <input type="text" v-model="editedItem.jointGuarantor.homePhone"
                       style="width:80px; margin-top:3px; margin-bottom:-5px">
              </td>
              <th>行&nbsp;動<br/>電&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.jointGuarantor.hasCellphone"></span>無
                </div>
                <input type="number" v-model="editedItem.jointGuarantor.cellphone"
                       style="width:80px; margin-top:3px; margin-bottom:-5px">
              </td>
            </tr>
            <tr>
              <th>公&nbsp;司<br/>名&nbsp;稱</th>
              <td colspan="3"><input type="text" v-model="editedItem.jointGuarantor.companyName"
                                     style="width:200px;"></td>
              <th>職&nbsp;稱</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.jointGuarantor.hasTitle"></span>無
                </div>
                <input type="text" v-model="editedItem.jointGuarantor.title"
                       style="width:80px; margin-top:3px; margin-bottom:-5px">
              </td>
              <th>公&nbsp;司<br/>電&nbsp;話</th>
              <td class="td-phone">
                <!-- <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.jointGuarantor.hasCompanyPhone"></span>無
                </div> -->
                <input type="text" placeholder="區碼" v-model="editedItem.jointGuarantor.companyTelCode" onKeyUp="value=value.replace(/\D/g,'')"
                       onchange="value=value.replace(/\D/g,'')"
                       maxlength="3" style="width:30px;">
                <input type="text" v-model="editedItem.jointGuarantor.companyPhone"
                       style="width:60px; margin-top:3px; ">
                <span class="ext">分機<input type="text" v-model="editedItem.jointGuarantor.companySubPhone"
                                             style="width:20px; margin-bottom:-5px;"></span>
              </td>
            </tr>
          </table><!--redTable-->
        </div><!--redBox-->
        <div class="yBox">
          <div class="ps">
            ※以下欄位由經銷商或債權讓與人填寫並經申請人及其連帶保證人確認無誤※此案件為:「
            <div class="checkDiv"><span class="checkbox">
                        <input type="checkbox" v-model="editedItem.caseInfo.type[0].value"></span>新件
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.type[1].value"></span>補保人
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.type[2].value"></span>補資料
            </div>
            」「
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.interestRate[0].value"></span>零利率
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.interestRate[1].value"></span>低利率
            </div>
            」「
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.category[0].value"></span>ㄧ般件
            </div>
            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                v-model="editedItem.caseInfo.category[1].value"></span>保密件」
            </div>

          </div>
          <div class="tit">經&nbsp;&nbsp;銷&nbsp;&nbsp;商&nbsp;&nbsp;填&nbsp;&nbsp;寫&nbsp;&nbsp;欄</div>
          <table class="yTable1">
            <tr class="yTr">
              <th width="20px" rowspan="2">分期內容</th>
              <th width="110px">商品名稱</th>
              <th width="73px" class="psTh1">頭款<span>(訂金)</span></th>
              <th width="65px">商品總價</th>
              <th width="155px" class="psTh2">辦理分期金額<span>(商品總價-已付頭款)</span></th>
              <th width="45px">期數</th>
              <th width="130px" class="psTh3">每期應繳金額<span>(期付款)</span></th>
              <th class="psTh4">分期總額<span>(期數X期付金額)</span></th>
            </tr>
            <tr>
              <td>
                <!--<input type="text" v-model="editedItem.vendor.productName"-->
                <!--style="width:90px; text-align:center">-->
                <!--              <select v-model="editedItem.vendor.productId" style="width:90px; text-align:center">-->
                <!--                <option v-for="type in getCaseTypeList" :key="type.key" :value="type.key">-->
                <!--                  {{type.value}}-->
                <!--                </option>-->
                <!--              </select>-->
                <span>機車</span>
              </td>
              <td>
                <!--<input type="text" v-model="editedItem.vendor.deposit"-->
                <!--style="width:50px; text-align:center">-->
              </td>
              <td>
                <input type="text" v-model="editedItem.vendor.totalPrice"
                       v-if="canCustomPrice"
                       style="width:50px; text-align:center"/>
                <select v-else v-model="editedItem.vendor.totalPrice" style="width:50px; text-align:center"
                        @change="changeInstallmentsNumber">
                  <option v-for="price in getCreditPriceList" :key="price" :value="price">
                    {{price}}
                  </option>
                </select>
                <!--<td><input type="text" v-model="editedItem.vendor.creditPrice" style="width:140px; text-align:center"></td>-->
              <td>
                <!--<select v-model="editedItem.vendor.creditPrice" style="width:140px; text-align:center"-->
                <!--@change="changeInstallmentsNumber">-->
                <!--<option v-for="price in getCreditPriceList" :key="price" :value="price">{{price}}</option>-->
                <!--</select>-->
              </td>
              <td>
                <input type="text" v-model="editedItem.vendor.installmentsNumber"
                       v-if="canCustomPrice"
                       style="width:50px; text-align:center"/>
                <select v-else v-model="editedItem.vendor.installmentsNumber" style="width:30px; text-align:center"
                        @change="changeInstallmentsNumber">
                  <option v-for="number in getInstallmentsNumberList" :key="number" :value="number">{{number}}</option>
                </select>
              </td>
              <!--<td><input type="text" v-model="editedItem.vendor.installmentsNumber" style="width:30px; text-align:center"></td>-->
              <td><input type="text" v-model="editedItem.vendor.creditPriceMonth"
                         style="width:110px; text-align:center"></td>
              <td>
                <input v-if="canCustomPrice" type="text" v-model="editedItem.vendor.totalCreditPrice"
                       style="width:110px; text-align:center">
                <span v-else>{{editedItem.vendor.totalCreditPrice}}</span>

              </td>
            </tr>
          </table><!--yTable1-->
          <table class="yTable2">
            <tr>
              <th width="70px">
                <span class="th1">經銷商或<br/>債權讓與人名稱<br/>(約定受款方)</span></th>
              <td width="133px">
                <!--<input type="text" v-model="editedItem.vendor.vendorName"-->
                <!--style="width:100px;">-->
              </td>
              <th width="65px">
                <span class="th2">經銷商或<br/>債權讓與人<br/>電話</span>
              </th>
              <td width="105px" class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.vendor.hasCellphone"
                                                                    disabled></span>無電話請打手機聯絡
                </div>
                <!--<input type="text" v-model="editedItem.vendor.cellphone"-->
                <!--style="width:80px; margin-top:5px;">-->
              </td>
              <th width="50px">
                <span class="th3">經銷商或<br/>債權讓與人<br/>傳真</span>
              </th>
              <td width="110px" class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.vendor.hasFax" disabled></span>無傳真請電話通知
                </div>
                <!--<input type="text" v-model="editedItem.vendor.fax" style="width:80px; margin-top:5px;">-->
              </td>
              <th rowspan="3" class="sign1">
                <span class="bg"></span>
                <span class="txt">(請蓋公司大小章或發票章)</span>
                <span class="ps">※債權轉讓確認章<br/>※遲延利息及委約金之請求權同意一併讓與受讓人</span>
              </th>
            </tr>
            <tr>
              <th>經辦店名稱</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.vendor.sameVendor"
                                                                    disabled></span>同經銷商或債權讓與人
                </div>
                <!--<input type="text" v-model="editedItem.vendor.salesName"-->
                <!--style="width:100px; margin-top:5px;">-->
              </td>
              <th>經辦店<br/>電&nbsp;&nbsp;話</th>
              <td class="td-phone">
                <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                    v-model="editedItem.vendor.hasSalesPhone"
                                                                    disabled></span>無電話請打手機聯絡
                </div>
                <!--<input type="text" v-model="editedItem.vendor.salesPhone"-->
                <!--style="width:80px; margin-top:5px;">-->
              </td>
              <th>經辦人<br/>手&nbsp;&nbsp;機</th>
              <td><input type="text" v-model="editedItem.vendor.salesCellphone"
                         style="width:80px; "></td>
            </tr>
            <tr>
              <td colspan="6" class="td-phone td-phone2">
                <div class="checkDiv checkDiv2">
                  經銷商備註欄：<br/>
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.vendor.type[0].value"></span>熟客&nbsp;
                  <span class="checkbox"><input type="checkbox" v-model="editedItem.vendor.type[1].value"></span>過路客&nbsp;
                  <span class="checkbox"><input type="checkbox"
                                                v-model="editedItem.vendor.type[2].value"></span>指定照會時間：<span
                  class="m"><input type="text" v-model="editedItem.vendor.checkTime.month"
                                   style="width:20px; margin-bottom:-5px "></span>月<span
                  class="d"><input type="text" v-model="editedItem.vendor.checkTime.day"
                                   style="width:20px; margin-bottom:-5px "></span>日
                  <span class="t"><input type="text" value=""
                                         style="width:20px; margin-bottom:-5px "></span>午<span
                  class="h"><input type="text" v-model="editedItem.vendor.checkTime.hour"
                                   style="width:20px; margin-bottom:-5px "></span>點<span
                  class="min"><input type="text" v-model="editedItem.vendor.checkTime.minute"
                                     style="width:20px; margin-bottom:-5px "></span>分
                </div>
                <span class="ps2"><input type="text" v-model="editedItem.vendor.comment"
                                         style="width:320px; padding:0; height:12px;"
                                         placeholder="備註"></span>
                <div class="sign2">
                  經辦人簽名
                  <span class="bg">
                                    <input type="text" v-model="editedItem.vendor.signature"
                                           style="width:85px; padding:0; height:15px;"></span>
                  <span class="txt">本人證實申請人及連帶保證人身分正確並親自簽章無誤</span>
                </div>
              </td>
            </tr>
          </table><!--yTable2-->
        </div><!--yBox-->
        <div class="gTit">約定事項</div>
        <div class="gContent">
          <ul class="gBoxCon" style="margin-top: -85px;">
            申請人（以下簡稱甲方）及其連帶保證人、經銷商或債權讓與人（以下簡稱乙方）及債權受讓人裕富數位資融（股）公司（以下簡稱裕富公司）三方同意訂定本購物分期付款申請暨約定書（以下簡稱本約定書），<span
            class="redHighlight">其個別商議及特別授權之約定事項如下：</span><br/>
            <li>
              甲方及其連帶保證人同意裕富公司得將甲方及其連帶保證人與裕富公司往來本契約之相關資料（包括但不限於基本資料、信用資料、財務資料等），提供予財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依其設立目的、章程及相關法令規定，蒐集、處理及利用甲方及其連帶保證人之資料，並已暸解及同意裕富公司及財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依個人資料保護法規定所告知之事項。財團法人金融聯合徵信中心及中華徵信所企業股份有限公司依其設立目的、章程及相關法令規定，得將本人資料提供與其參與徵信資料交換及利用之會員、融資租賃業、金融目的事業主管機關及其他依法令得蒐集、處理及利用資料之人。甲方及其連帶保證人確認已受個人資料保護法第三條、第八條及第九條告知且留存本約定書繕本，得憑之主張相關權利。
            </li>
            <li>
              甲方及其連帶保證人同意裕富公司得於履行契約及商品推廣、市場調查、數據分析之目的範圍內，依個人資料保護法相關規定以電腦蒐集、處理、利用甲方及其連帶保證人提供之前述基本資料（不包括財團法人金融聯合徵信中心及中華徵信所企業股份有限公司查詢之信用資料），並向相關之個人、機關、法人等查詢該等資料及往來紀錄，亦同意裕富公司得將前述往來之資料，提供予（一）受讓（或擬受讓）裕富公司債權之債權人，（二）受裕富公司委任代為處理事務之人或與裕富公司有簽約之委外合作廠商，（三）裕富公司之分公司，（四）裕隆汽車製造（股）公司及其相關企業／裕融企業及其關係企業，（五）財團法人金融聯合徵信中心，（六）逾期催收之受託公司（限甲方及其連帶保證人違約時）。但甲方及其連帶保證人得隨時要求停止對其相關資料交互運用。<span
              class="redHighlight">申請人就本項約定：<div class="checkDiv"><span class="checkbox"><input
              type="checkbox" v-model="editedItem.agree[0].value"></span>同意</div><div
              class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                             v-model="editedItem.agree[1].value"></span>不同意</div>（若未勾選視為不同意）；連帶保證人就本項約定：
                            <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                                v-model="editedItem.agree[2].value"></span>同意</div><div
                class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                               v-model="editedItem.agree[3].value"></span>不同意</div>（若未勾選視為不同意）</span>
            </li>
            <li>
              甲方及其連帶保證人已受說明／告知本約定書重要內容及相關權利義務，並已充分暸解本約定書之重要內容及相關權利義務，且同意乙方或裕富公司得修正本約定書（共二頁）所填資料，並同意申請時所提供之資料及本約定書正本不予退還。
            </li>
            <li>甲方及其連帶保證人已攜回本約定書審閱，並經給予五日以上之期間詳閱並充分了解本契約之全部條款後簽訂本約定書。</li>
            <li>
              甲方及其連帶保證人於簽約時已充分暸解並同意，乙方將請求支付分期價款之權利及依本約定書約定所得享受之其他一切權利及利益（含延遲利息及違約金）讓與裕富公司，裕富公司並依約付款予乙方或撥入「指示付款同意暨約定書」所指定之帳戶以為收買應收帳款之債權。甲方及其連帶保證人並於裕富公司依約為上述撥付款項時即為知悉債權讓與事實，並應依約繳款予裕富公司。
            </li>
            <li>分期價金還款方式與內容：本分期依經銷商填寫欄內容自撥款日次月起每月一期，依年金計法計算，按月平均攤還本息予裕富公司。</li>
            <li>甲方申辦之機車分期付款業務，車牌號碼：<input type="text" v-model="editedItem.carInfo.carId" style="width:100px">；甲方同意將前述車輛車牌領牌登記於二等親屬（姓名：<input
              type="text" v-model="editedItem.carInfo.name" style="width:100px">、身分證字號：<input type="text"
                                                                                                   v-model="editedItem.carInfo.memberId"
                                                                                                   style="width:100px">、與甲方關係為
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[0].value"></span>本人之父／母
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[1].value"></span>子／女
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[2].value"></span>兄／弟
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[3].value"></span>姊／妹
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[4].value"></span>祖父／母
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[5].value"></span>外祖父／母
              </div>
              <div class="checkDiv"><span class="checkbox"><input type="checkbox"
                                                                  v-model="editedItem.carInfo.relationship[6].value"></span>孫／孫女／外孫／外孫女
              </div>
              ）之名下（並檢附證明），全部分期付款概由甲方負責。
            </li>
            <li>
              甲方及其連帶保證人同意特別授權如下：（一）甲方及其連帶保證人同意裕富公司將款項撥入甲方與乙方所指定之帳戶時，授權裕富公司及其指定人填載本票發票日（即撥款日）及本票金額（即分期總額）、付款地，甲方及其連帶保證人絕無異議。（二）甲方及其連帶保證人倘有違反本約定書任一條款或延遲繳納分期款項時，甲方及其連帶保證人均授權裕富公司及其指定人得不經過通知逕行填載本票到期日，並主張票據權利。(三) 本票供為分期付款買賣之分期款項總項憑證，俟分期付款完全清償完畢時，本票自動失效，但如有一期未付，發票人就全部本票債務負責清償。
            </li>
            <li>
              本債權讓與契約目的係甲方為購買上開商品名稱欄位標的物，並由甲方指示裕富公司將辦理分期金額逕予撥款至甲乙雙方指定帳戶，本債權讓與契約之債權受讓人為「裕富數位資融 ( 股 ) 公司」，客服電話 :(02)6638-7799，相關聯繫
              資訊，請以裕富公司網站 (https://9797888.yurich.com.tw/)公告為據。
            </li>
            <li>
              乙方如有歇業、停業等無法繼續提供預付型商品或服務時，甲方得檢附催告乙方之存證信函或其他得證明乙方已無法繼續提供服務之證明，向裕富公司申請止付乙方未提供服務部分之分期餘額。但乙方已有提供履約擔保者，不在此限。
            </li>
            <li>終止或解除商品或服務契約，本債權讓與契約亦同時終止或解除。惟商品或服務契約之終止或解除，乙方能證明係因可歸責於甲方之事由所致者，裕富公司得逕向甲方收取乙方已提供服務之分期款。
              <br><span class="redHighlight">※***甲方、甲方之法定代理人及甲方之連帶保證人確認已充分詳閱及了解並同意本約定書及其個別商議及特別授權之約定事項各款內容並確認簽章：</span>
            </li>
          </ul><!--gBoxCon-->
        </div><!--約定事項gContent-->
        <div class="signBlue">
          甲方<span class="s">(申請人)</span><br/>
          簽&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名
          <img class="box" :src="signImageSrc('signImage1')"/>
          <div class="box"
               style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
               @click="showSignDialog('customer')"></div>
          <!--<span class="box"></span>-->
        </div>
        <div class="signRed">
          甲&nbsp;方&nbsp;連&nbsp;帶<br/>
          保證人簽章
          <img class="box" :src="signImageSrc('signImage3')"/>
          <div class="box"
               style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
               @click="showSignDialog('jointGuarantor')"></div>
          <!--<span class="box"></span>-->
        </div>
        <div class="signGreen">
          甲&nbsp;方&nbsp;法&nbsp;定<br/>
          代理人簽名
          <span class="box"></span>
          <span class="box2"></span>
        </div>
        <div class="dot"><span>(續下頁)</span></div>
        <div class="bottomTit">&#9826本票</div>
        <div class="bottomCon">
          憑票於中華民國<input type="text" v-model="editedItem.promisedNote.promisedDate.year"
                               style="width:40px; text-align:center; height:16px; margin:0 3px;">年
          <input type="text" v-model="editedItem.promisedNote.promisedDate.month"
                 style="width:40px; text-align:center; height:16px; margin:0 3px;">月
          <input type="text" v-model="editedItem.promisedNote.promisedDate.day"
                 style="width:40px; text-align:center; height:16px; margin:0 3px;">日無條件支付裕富數位資融股份有限公司<br/>
          新台幣<input type="text" v-model="editedItem.promisedNote.money.one"
                       style="width:75px; text-align:center; height:16px; margin:0 3px;">拾
          <input type="text" v-model="editedItem.promisedNote.money.two"
                 style="width:75px; text-align:center; height:16px; margin:0 3px;">萬
          <input type="text" v-model="editedItem.promisedNote.money.three"
                 style="width:75px; text-align:center; height:16px; margin:0 3px;">仟
          <input type="text" v-model="editedItem.promisedNote.money.four"
                 style="width:75px; text-align:center; height:16px; margin:0 3px;">佰
          <input type="text" v-model="editedItem.promisedNote.money.five"
                 style="width:75px; text-align:center; height:16px; margin:0 3px;">拾
          <input type="text" v-model="editedItem.promisedNote.money.six"
                 style="width:75px; text-align:center; height:16px; margin:0 3px;">元整<span class="ps3">(本票金額可填大寫或阿拉伯數字，二擇一)</span>
          <span class="ps1">此本票免除做成拒絕證書及票據法第八十九條之通知義務，利息自到期日迄清償日止按年息百分之十六計付，發票人授權持票人得填載到期日。</span>
          <br/>
          付款地：<input type="text" v-model="editedItem.promisedNote.paymentCity"
                        style="width:100px; height:16px; margin:0 3px;"><br/>
          中華民國<input type="text" v-model="editedItem.promisedNote.createDate.year"
                         style="width:30px; text-align:center; height:16px; margin:0 3px;">年
          <input type="text" v-model="editedItem.promisedNote.createDate.month"
                 style="width:25px; text-align:center; height:16px; margin:0 3px;">月
          <input type="text" v-model="editedItem.promisedNote.createDate.day"
                 style="width:25px; text-align:center; height:16px; margin:0 3px;">日1.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <!--<span class="box1"></span>-->
          <img class="box1" :src="signImageSrc('signImage2')"/>
          <div class="box1"
               style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
               @click="showSignDialog('invoiceSign')"></div>
          2.發票人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <!--<span class="box2"></span>-->
          <img class="box2" :src="signImageSrc('signImage3')"/>
          <div class="box2"
               style="z-index: 100; background: transparent; border: transparent 1px;" type="text"
               @click="showSignDialog('jointGuarantor')"></div>
          3.發票人：
          <span class="box3"></span>
          <div class="signAll">法定代理人：<span class="box4"></span><span class="box5"></span></div>
          <span class="ps2">「此本票供為分期付款買賣之分期款項總項憑證，俟分期付款完全清償完畢時，此本票自動失效，但如有一期未付，發票人就全部本票債務負責清償」</span>

        </div><!--bottomCon-->
      </div><!--page2-->

      <div class="btn">
        <span class="mr-2 subheading red--text" v-if="loading">案件上傳中 請勿關閉視窗</span>
        <v-btn class="primary center" dark text :loading="loading" @click="save">確認上傳</v-btn>
        <!-- <a href="" @click.prevent="save">確認上傳</a> -->
      </div>

      <v-card v-if="isSaveSuccess">
        <v-card-title class="title">
          添加審核照片
        </v-card-title>
        <upload-view :item-detail="editedItem"
                     :show-upload-button="true"
                     :uploadType="uploadType" @onFinishUpload="onFinishUpload"></upload-view>
      </v-card>

      <v-card v-if="(editedItem.fileList && editedItem.fileList.length)
      || (hasAttachmentFile)">
        <div class="pb-2 mb-2">
          <v-card-title>
            <span class="title">PDF檔 / Zip檔</span>
          </v-card-title>
          <v-layout ml-2 v-for="(file, i) in editedItem.fileList" :key="i">
            <v-flex ml-2>
              <a class="subheading" :href="file.data" target="_blank">
                {{file.imageName}}
              </a></v-flex>
          </v-layout>
          <v-layout v-if="hasAttachmentFile" ml-2
                    v-for="(file, i) in attachmentFile.attachmentFiles" :key="i">
            <v-flex ml-2>
              <a class="subheading" :href="file.url" target="_blank">
                {{file.fileName}}
              </a></v-flex>
          </v-layout>
          <v-layout v-if="caseExamList.length" ml-2
                    v-for="(exam, i) in caseExamList" :key="`exam_${i}`">
            <v-flex ml-2>
              <a class="subheading" v-if="exam.fileURL" :href="exam.fileURL" target="_blank">
                申覆檔案({{exam.createdDate}})
              </a></v-flex>
          </v-layout>
        </div>
      </v-card>

      <div class="photo_page_wrapper" v-if="editedItem.imageList && editedItem.imageList.length">
        <v-card>
          <!--<div class="box" v-for="image in editedItem.imageList"><img  :src="image.data"></div>-->
          <v-layout md12 row wrap>
            <v-flex md6 mt-2 v-for="(image, i) in editedItem.imageList"
                    :key="i">
              <div class="box"><img :src="image.data"></div>
            </v-flex>
          </v-layout>
        </v-card><!--page-->
      </div><!--wrapper-->

      <!--申辦條件-->
      <v-dialog
        v-model="checkDialog.visible"
        :width="isMobile ? '90%' : '60%'">
        <v-card>
          <v-card-title class="headline">
            {{checkDialog.text}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout justify-end row>
              <v-btn color="primary" dark text @click="checkDialog.confirm">確定</v-btn>
            </v-layout>

            <v-checkbox class="title" v-model="editedItem.isWork8month" :label="'正職是否滿8個月'"></v-checkbox>
            <hr class="mb-2">
            <v-layout v-for="(item, i) in getRequireCheckList" :key="item.key">
              <v-flex xs12>
                <span class="title">{{item.title}}</span>
                <v-checkbox class="title" v-model="requireOption[i].value" :label="item.text"></v-checkbox>
              </v-flex>
            </v-layout>
            <hr>
            <v-layout row wrap v-for="item in getCheckList" :key="item.key">
              <v-flex xs12>
                <span class="title">{{item.title}}</span>
                <v-checkbox class="title" v-if="requireOption[0].value === true && item.key ===  6" :label="item.text" disabled></v-checkbox>
                <v-checkbox class="title" v-else-if="requireOption[1].value === true && item.key === 3" :label="item.text" disabled></v-checkbox>
                <v-checkbox class="title" v-else-if="editedItem.vendor.productId === '1' && item.key === 8" :label="item.text" disabled></v-checkbox>
                <v-checkbox class="title" v-else-if="editedItem.vendor.productId === '2' && item.key === 9" :label="item.text" disabled></v-checkbox>
                <v-checkbox class="title" v-else v-model="item.value" :label="item.text"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark text @click="checkDialog.confirm">確定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dateInfoDialog.visible"
        :width="isMobile ? '90%' : '60%'">
        <v-card>
          <v-card-title class="headline">
            {{dateInfoDialog.text}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap v-if="dateInfoDialog.key === 'birthday'">
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.birthdayInfo.year" length="3" maxlength="3"
                              placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.birthdayInfo.month" length="2" maxlength="2"
                              placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.birthdayInfo.day" length="2" maxlength="2"
                              placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>

            <div v-if="dateInfoDialog.key === 'memberIdDate'">
              <v-layout row wrap>
                <v-flex sm3>
                  <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.year" length="3" maxlength="3"
                                placeholder="年(民國)"></v-text-field>
                </v-flex>
                <v-flex sm3>
                  <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.month" length="2" maxlength="2"
                                placeholder="月(ex. 01)"></v-text-field>
                </v-flex>
                <v-flex sm3>
                  <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.day" length="2" maxlength="2"
                                placeholder="日(ex. 01)"></v-text-field>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="dateInfoDialog.key === 'jointGuarantor.birthday'">
              <v-layout row wrap>
                <v-flex sm3>
                  <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.year" length="3" maxlength="3"
                                placeholder="年(民國)"></v-text-field>
                </v-flex>
                <v-flex sm3>
                  <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.month" length="2" maxlength="2"
                                placeholder="月(ex. 01)"></v-text-field>
                </v-flex>
                <v-flex sm3>
                  <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.day" length="2" maxlength="2"
                                placeholder="日(ex. 01)"></v-text-field>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="dateInfoDialog.key === 'jointGuarantor.memberIdDate'">
              <v-layout row wrap>
                <v-flex sm3>
                  <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.year" length="3" maxlength="3"
                                placeholder="年(民國)"></v-text-field>
                </v-flex>
                <v-flex sm3>
                  <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.month" length="2" maxlength="2"
                                placeholder="月(ex. 01)"></v-text-field>
                </v-flex>
                <v-flex sm3>
                  <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.day" length="2" maxlength="2"
                                placeholder="日(ex. 01)"></v-text-field>
                </v-flex>
              </v-layout>
            </div>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary" dark text @click="dateInfoDialog.confirm">確定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        fullscreen hide-overlay
        v-model="signDialog.visible">
        <v-card>
          <v-card-text>
            <draw-canvas :visible="signDialog.visible"
                         @handleDownloadSign="handleDownloadSign"  @closeEvent="handleDownloadClose"></draw-canvas>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="cityInfoDialog.visible"
        :width="isMobile ? '90%' : '50%'">
        <v-card>
          <v-card-title class="headline">
            {{cityInfoDialog.text}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-select :items="getMemberIdCityList"
                      item-text="value"
                      item-value="key"
                      v-model="cityInfoDialog.value"
                      label="發證地點"
            ></v-select>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary" dark text @click="cityInfoDialog.confirm">確定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--提示-->
      <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  :show-cancel="messageDialog.showCancel"
                  @confirmEvent="messageDialog.confirm"
                  @cancelEvent="messageDialog.cancel"></alert-view>
    </div><!--wrapper-->
  </v-app>
</template>

<script>
import UploadView from '../../components/UploadView';
import dateTimeTool from '@/components/dateTimeTool';
import DrawCanvas from '@/components/DrawCanvas';
import { mapActions, mapGetters } from 'vuex';
import ApplicationModel from '../../models/ApplicationModel';
import common from '../../mixins/common';
import AlertView from '@/components/AlertView';
import {  getCreditLoanFiles } from "../utils/tool";

export default {
  name: 'EditInstallmentProductView',
  props: {
    loading: Boolean,
    loadingText: String,
    isSaveSuccess: Boolean,
    cellphone: String,
  },
  components: { dateTimeTool, DrawCanvas, UploadView, AlertView },
  data() {
    return {
      requireOption:[{
        value: false,
      },
        {
          value: false,
        }],
      caseExamList:[],
      uploadType: 'add',
      tab: '0',
      firstTipCount: 0,
      secondTipCount: 0,
      photoDialog: {
        title: '',
        text: '',
        visible: false,
        loading: false,
        message: '',
        confirm: () => {
        },
        cancel: () => {
        },
      },
      signDialog: {
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      checkDialog: {
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      dateInfoDialog: {
        key: '',
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      cityInfoDialog: {
        key: '',
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      priceData: require('../../assets/finance_bonus_AA21'),
      creditPriceData: require('../../assets/credit_price'),
      cityData: require('../../assets/taiwan_city'),
      cityList: [],
      areaList: {},
      valid: true,
      dialog: false,
      editedIndex: -1,
      editedItem: null,
      defaultItem: new ApplicationModel(),
      messageDialog: {
        title: '',
        text: '',
        visible: false,
        showCancel: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      items: [],
      signKey: 'customer',
      attachmentFile: {
        attachmentFiles:[],
      },
      isGuarantor:false
    };
  },
  created() {
    this.tab = this.$route.query.tab;
    console.log(`tab === ${this.tab}`);
    this.editedIndex = this.$route.query.editIndex;
    console.log(`Edit this.editedIndex  == ${this.editedIndex} / ${this.cellphone}`);
    this.isGuarantor = !!parseInt(this.$route.query.guarantor);
    console.log(`isGuarantor ${this.$route.query.guarantor}`)
    this.cityData.taiwan.forEach((city) => {
        this.cityList.push(city.city);
        this.areaList[city.city] = city.area;
    });

    if (this.editedIndex === 0 || this.editedIndex === '0') { // 編輯
      const caseId = this.$route.query.caseId;
      console.log(`Edit Credit caseId == ${caseId}`);

      this.editedItem = Object.assign(this.defaultItem);
      this.fetchCreditProductInfo({ caseId: this.$route.query.caseId })
        .then(async (results) => {
          if (results.length === 0) { // 重複
            this.showMessageDialog('錯誤', '查無資料', true, () => {
            }, () => {
            });
          } else {

            this.editedItem = results[0];
            console.log(`Edit Credit caseId == ${JSON.stringify(this.editedItem)}`);

            this.loadExamData();

            this.tab = this.editedItem.tab;
            if (!this.editedItem.header.type) {
              this.editedItem.header.type = [
                { key: 0, value: false },
                { key: 1, value: false },
              ];
            }
            if (!this.editedItem.header.caseType4) {
              this.editedItem.header.caseType4 = '';
            }
            if (!this.editedItem.vendor.signature) {
              this.editedItem.vendor.signature = '';
            }
            if (!this.editedItem.customer.birthdayInfo) {
              this.$set(this.editedItem.customer, 'birthdayInfo', {
                year: '',
                month: '',
                day: '',
                isRepublic: true,
                startCount: 0,
              });
            }
            if (!this.editedItem.customer.memberIdDateInfo) {
              this.$set(this.editedItem.customer, 'memberIdDateInfo', {
                year: '',
                month: '',
                day: '',
                isRepublic: true,
                startCount: 0,
              });
            }
            if (!this.editedItem.signImage0) {
              this.editedItem.signImage0 = null;
            }
            if (!this.editedItem.signImage1) {
              this.editedItem.signImage1 = null;
            }
            if (!this.editedItem.signImage2) {
              this.editedItem.signImage2 = null;
            }
            if (!this.editedItem.signImage3) {
              this.editedItem.signImage3 = null;
            }
            if (!this.editedItem.signImage0Url) {
                this.editedItem.signImage0Url = null;
              }
              if (!this.editedItem.signImage1Url) {
                this.editedItem.signImage1Url = null;
              }
              if (!this.editedItem.signImage2Url) {
                this.editedItem.signImage2Url = null;
              }
              if (!this.editedItem.signImage3Url) {
                this.editedItem.signImage3Url = null;
              }
            if (!this.editedItem.customer.isSecret) {
              this.$set(this.editedItem.customer, 'isSecret', false);
            }
            if (!this.editedItem.company.isSecret) {
              this.$set(this.editedItem.company, 'isSecret', false);
            }
            if (!this.editedItem.firstContact.isSecret) {
              this.$set(this.editedItem.firstContact, 'isSecret', false);
            }
            if (!this.editedItem.secondContact.isSecret) {
              this.$set(this.editedItem.secondContact, 'isSecret', false);
            }
            if (!this.editedItem.vendor.productId) {
              this.$set(this.editedItem.vendor, 'productId', '0');
            }
            if (!this.isWork8month) {
              this.editedItem.isWork8month = false;
            }
            if (this.editedItem.officialItem){
              // 優加
              const isQuality = !!~['DL01','DL04','DM64','DM26','DM66','DN46','DN79','DN77'].indexOf(this.editedItem.officialItem.promotionId)
              if (isQuality || this.editedItem.header.caseType4){
                // this.editedItem.header.caseType4 = '9';
                this.editedItem.header.type[0].value = true;
              }
              const isGeneral = !!~['DL02','DL05','DM65','DM45','DM27','DM67','DN47','DN78', 'DN82','DN80'].indexOf(this.editedItem.officialItem.promotionId)
              if (isGeneral){
                this.editedItem.header.type[1].value = true;
              }
              if (this.editedItem.officialItem.busType === 'AA21'){
                this.editedItem.vendor.productId = 0;
                this.editedItem.vendor.productName = "原車";
              }
              if (this.editedItem.officialItem.busType === 'AA22'){
                this.editedItem.vendor.productId = 1;
                this.editedItem.vendor.productName = "借新";
              }
              if (this.editedItem.officialItem.busType === 'AA23'){
                this.editedItem.vendor.productId = 2;
                this.editedItem.vendor.productName = "代償";
              }
              if (this.editedItem.officialItem.busType === 'CA20'){
                this.editedItem.vendor.productId = 3;
                this.editedItem.vendor.productName = "商品貸";
              }
            }

            if (!this.editedItem.carInfo) {
              this.editedItem.carInfo = {
                carId: '',
                name: '',
                memberId: '',
                relationship: [
                  { key: 0, value: false },
                  { key: 1, value: false },
                  { key: 2, value: false },
                  { key: 3, value: false },
                  { key: 4, value: false },
                  { key: 5, value: false },
                  { key: 6, value: false },
                ],
              };
            }

            if(this.isGuarantor) {
              this.editedItem.caseId = Math.uuidFast();
              let newItem = new ApplicationModel();
              this.editedItem.jointGuarantor = newItem.jointGuarantor;
            }
          }

          const result = await this.getFinanceOfficialData({ caseId: this.editedItem.caseId });
          if (result){
            this.attachmentFile = result;
            console.log(`attachmentFile ${JSON.stringify(this.attachmentFile)}`);
          }
          if(this.editedItem.caseStatus === 3) {
            this.calculationTotal()
          }
          const creditLoanFiles = getCreditLoanFiles(this.editedItem)
          if(creditLoanFiles.length > 0) {
            creditLoanFiles.forEach(item => {
              this.attachmentFile.attachmentFiles.push(item)
            })
          }
        });
    } else {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.tab = this.tab;
      this.editedItem.caseId = Math.uuidFast();
      this.editedItem.displayId = '';
      this.editedItem.category = parseInt(this.$route.query.caseCategory);
      this.editedItem.customer.cellphone = this.cellphone;
      this.editedItem.customer.usePhonePayment = true;

      const now = new Date();
      this.defaultItem.applyDate.year = `${now.getFullYear() - 1911}`;
      this.defaultItem.applyDate.month = `${now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1}`;
      this.defaultItem.applyDate.day = `${now.getDate() + 1 < 10 ? `0${now.getDate()}` : now.getDate()}`;

      this.editedItem.vendor.productId = '0';
      this.editedItem.vendor.productName = '原車';
    }

    if (this.getAgentInfo) {
      if (this.getAgentInfo.enableFinanceAgent) {
        this.editedItem.vendor.salesCellphone = this.getAgentInfo.financePhone;
        this.editedItem.vendor.signature = this.getAgentInfo.financeName;
      }
    }
  },
  mixins:[common],
  watch: {
  },
  computed: {
    ...mapGetters(['getUserInfo', 'getAgentList', 'getCreditItem', 'getAgentInfo']),
    hasAttachmentFile(){
      // console.log(`hasAttachmentFile ${this.attachmentFile} / ${this.attachmentFile.attachmentFiles} / ${this.attachmentFile.attachmentFiles.length}`);
      return this.attachmentFile.attachmentFiles.length > 0;
    },
    canCustomPrice(){
      if (this.getAgentInfo.enableEditPrice === true
        || this.isAdmin){
        return true;
      }
      return false;
    },
    isEnableFinanceAgent() {
      if (this.getAgentInfo) {
        if (this.getAgentInfo.enableFinanceAgent) {
          this.editedItem.vendor.salesCellphone = this.getAgentInfo.financePhone;
          this.editedItem.vendor.signature = this.getAgentInfo.financeName;
        }
        return this.getAgentInfo.enableFinanceAgent;
      }
      return false;
    },
    getCreditPriceList() {
      const list = [];
      let end = 350000;
      // 機車原融、借新還舊最高十五萬  7/4開放至20萬
      // if (this.editedItem.vendor.productId === "0") {
      //   end = 150000;
      // }
      for (let i = 30000; i <= end; i += 10000) {
        list.push(i);
      }
      return list;
    },
    getInstallmentsNumberList() {
      // if (this.isAdmin) {
      //   return [12, 15, 18, 20, 24, 30, 36, 48, 50];
      // }
      // 機車原融 50期
      if (this.editedItem.vendor.productId === "0") {
        if (this.editedItem.header.type[1].value === true){ //一般件30期
          return [12, 15, 18, 20, 24, 30, 36, 48, 50];
        }
        return [12, 15, 18, 20, 24, 30, 36, 48, 50];
      }
      if (this.editedItem.vendor.productId === "2") { //他行代償24期
        return [12, 15, 18, 20, 24, 30, 36, 48, 50];
      }
      return [12, 15, 18, 20, 24, 30, 36, 48, 50];
    },
    yearList() {
      const start = new Date().getFullYear();
      const end = 1911;
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i - 1911}`, name: `${i - 1911}` });
      }
      return list;
    },
    monthList() {
      return [
        { name: '01', key: '01' },
        { name: '02', key: '02' },
        { name: '03', key: '03' },
        { name: '04', key: '04' },
        { name: '05', key: '05' },
        { name: '06', key: '06' },
        { name: '07', key: '07' },
        { name: '08', key: '08' },
        { name: '09', key: '09' },
        { name: '10', key: '10' },
        { name: '11', key: '11' },
        { name: '12', key: '12' },
      ];
    },
    dayList() {
      const startIndex = 1;
      const list = [];
      for (let i = startIndex; i <= 31; i++) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    },
    getCaseTypeList() {
      return this.getSampleCaseTypeList;
    },
    getVendorType() {
      if (this.editedItem.vendor.productId) {
        return this.editedItem.vendor.productId;
      }
      return 0;
    },
    checkCaseType(){
      if (!!this.editedItem.header.caseType4 || this.editedItem.header.type[1].value) {
          return true
      }
      if(this.editedItem.vendor.productId === '3'){
        this.editedItem.header.caseType = ''
        return true;
      } else {
        return false;
      }
    },
    checkCaseType4(){
      if (!!this.editedItem.header.caseType || this.editedItem.header.type[1].value) {
          return true
      }
      if(this.editedItem.vendor.productId === '1'){
        this.editedItem.header.caseType4 = ''
        return true;
      } else {
        return false;
      }
    },
    checkType1() {
      return (!!this.editedItem.header.caseType4 || !!this.editedItem.header.caseType);
    },
    checkMemberIdCityNumberType(){
      if(this.editedItem) {
        const value = this.editedItem.customer.memberIdCity.replace(/ /g,'')
        if (!value) {
          return false
        }
        const parsed = parseInt(value, 10);
        return isNaN(parsed)
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(['fetchAgentList', 'fetchCreditProductInfo','getFinanceOfficialData','uploadImageData', 'fetchExamList']),
    async loadExamData() {
      const res = await this.fetchExamList({ displayId: this.editedItem.displayId });
      const result = res.data;
      console.log(`fetchExamList result ${JSON.stringify(result)}`);
      if (result.statusCode === 0) {
        if (result.data) {
          this.caseExamList = result.data.list;
        } else {
          this.caseExamList = [];
        }
      }
    },
    signImageSrc(itemPath){
        let source = null;
        if (itemPath === 'signImage1'){
          if (this.editedItem.signImage1) {
            source = this.editedItem.signImage1;
          } else if(this.editedItem.signimage1Url) {
            source = this.editedItem.signimage1Url;
          }
        } else if(itemPath === 'signImage2'){
          if (this.editedItem.signImage2){
            source = this.editedItem.signImage2;
          } else if(this.editedItem.signimage2Url) {
            source = this.editedItem.signimage2Url;
          }
        } else if(itemPath === 'signImage3'){
          if (this.editedItem.signImage3){
            source = this.editedItem.signImage3;
          } else if(this.editedItem.signimage3Url) {
            source = this.editedItem.signimage3Url;
          }
        }
        return source;
      },
    checkHomeType() {
      if (this.editedItem.customer.home.homeType1[0].value) {
        this.editedItem.customer.home.homePost = this.editedItem.customer.home.residencePost;
        this.editedItem.customer.home.homeCity = this.editedItem.customer.home.residenceCity;
        this.editedItem.customer.home.homeArea = this.editedItem.customer.home.residenceArea;
        this.editedItem.customer.home.homeAddress1 = this.editedItem.customer.home.residenceAddress;
      } else {
        this.editedItem.customer.home.homePost = '';
        this.editedItem.customer.home.homeCity = '';
        this.editedItem.customer.home.homeArea = '';
        this.editedItem.customer.home.homeAddress1 = '';
      }
    },
    async handleDownloadSign(image) {
      console.log(`handleDownloadSign == ${image}`);
      if (this.signKey === "jointGuarantor") {
        this.editedItem.signImage3 = image;
      } else {
        this.editedItem.signImage0 = image;
        this.editedItem.signImage1 = image;
        this.editedItem.signImage2 = image;
      }

      this.signDialog.visible = false;
      this.signDialog.confirm = () => {
        if (this.signKey === "jointGuarantor") {
          this.editedItem.signImage3 = image;
        } else {
          this.editedItem.signImage0 = image;
          this.editedItem.signImage1 = image;
          this.editedItem.signImage2 = image;
        }
        this.signDialog.visible = false;
      };
    },
    handleDownloadClose() {
      this.signDialog.visible = false
    },
    showSignDialog(key) {
      this.signKey = key;
      this.signDialog.visible = true;
    },
    checkRequireOptions(){
      const checkRequireCount = this.requireOption.filter(m=>m.value === true);
      return checkRequireCount.length === 2;
    },
    showCheckDialog(type) {
      console.log(`caseType ${this.editedItem.header.caseType} caseType4 ${this.editedItem.header.caseType4}`)
      const typeText = type === 0 ? '請選擇優加符合項目' : '請選擇優質符合項目'
      this.checkDialog.visible = true;
      this.checkDialog.text = typeText;
      this.checkDialog.confirm = () => {
        // console.log(JSON.stringify(this.getCheckList));
        const checkRequireCount = this.requireOption.filter(m=>m.value === true);
        const checkCount = this.getCheckList.filter(m=>m.value === true);
        console.log(`checkCount == ${checkRequireCount.length} / ${checkCount.length} / ${this.editedItem.vendor.productId} | ${this.getCheckList[0].value}`);
        this.editedItem.header.caseType5 = '';
        this.editedItem.header.caseType = '';
        this.editedItem.header.caseType4 = '';
        let i = 0;
        let requireContent = '';
        for (let option of this.getRequireCheckList){
          if (this.requireOption[i].value){
            requireContent += `${option.option} `;
          }
          i++;
        }
        if (checkRequireCount.length === 0 && checkCount.length === 1){ // 優質專案
          for (let item of this.getCheckList){
            if (item.value) {
              requireContent += `${item.key + 1} `;
            }
          }
          this.editedItem.header.caseType4 += requireContent;
          this.editedItem.caseType = 1;
        } else if (checkRequireCount.length === 0 && checkCount.length > 1 && this.getCheckList[0].value === false){ // 優質專案
          for (let item of this.getCheckList){
            if (item.value) {
              requireContent += `${item.key + 1} `;
            }
          }
          this.editedItem.header.caseType4 += requireContent;
          this.editedItem.caseType = 1;
        }  else if (checkRequireCount.length > 0  || (checkCount.length > 1 && this.getCheckList[0].value === true)){ // 優加專案
          for (let item of this.getCheckList){
            if (item.value) {
              requireContent += `${item.key + 1} `;
            }
          }
          if (checkRequireCount.length > 0){
            this.editedItem.header.caseType5 += requireContent;
            this.editedItem.caseType = 3; // 超優
          } else {
            this.editedItem.header.caseType += requireContent;
            this.editedItem.caseType = 1; // 優質
          }
        }
        this.checkDialog.visible = false;
      };
    },
    showDateToolDialog(key) {
      console.log(`showDateToolDialog ${key}`);
      this.dateInfoDialog.key = key;
      this.dateInfoDialog.visible = true;
      this.dateInfoDialog.text = '請選擇日期';
      this.dateInfoDialog.confirm = () => {
        if (key === 'birthday') {
          this.editedItem.customer.birthday = `${this.editedItem.customer.birthdayInfo.year}年${this.editedItem.customer.birthdayInfo.month}月${this.editedItem.customer.birthdayInfo.day}日`;
        }
        if (key === 'memberIdDate') {
          this.editedItem.customer.memberIdDate = `${this.editedItem.customer.memberIdDateInfo.year}年${this.editedItem.customer.memberIdDateInfo.month}月${this.editedItem.customer.memberIdDateInfo.day}日`;
        }
        if (key === 'jointGuarantor.birthday') {
          this.editedItem.jointGuarantor.birthday = `${this.editedItem.jointGuarantor.birthdayInfo.year}年${this.editedItem.jointGuarantor.birthdayInfo.month}月${this.editedItem.jointGuarantor.birthdayInfo.day}日`;
        }
        if (key === 'jointGuarantor.memberIdDate') {
          this.editedItem.jointGuarantor.memberIdDate = `${this.editedItem.jointGuarantor.memberIdDateInfo.year}年${this.editedItem.jointGuarantor.memberIdDateInfo.month}月${this.editedItem.jointGuarantor.memberIdDateInfo.day}日`;
        }
        this.dateInfoDialog.visible = false;
      };
    },
    showCityDialog() {
      this.cityInfoDialog.visible = true;
      this.cityInfoDialog.text = '請選擇發證地點';
      this.cityInfoDialog.confirm = () => {
        this.editedItem.customer.memberIdCity = this.cityInfoDialog.value;
        this.cityInfoDialog.visible = false;
      };
    },
    changeInstallmentsNumber() {
      const find = this.priceData["0"][this.editedItem.vendor.installmentsNumber][0];

      // const key = `${this.editedItem.vendor.totalPrice}-${this.editedItem.vendor.installmentsNumber}`;
      // const find = this.creditPriceData[key];
      if (find) {
        // console.log(`${parseInt(this.editedItem.creditPriceMonth)} / ${parseInt(find.price)}`);
        const price = find.monthPrice * (this.editedItem.vendor.totalPrice / 10000)

        this.editedItem.vendor.creditPriceMonth = parseInt(price);
        this.calculationTotal();
        // console.log(`${JSON.stringify(this.editedItem)}`);
      }
    },
    calculationTotal(){
      this.editedItem.vendor.totalCreditPrice = parseInt(this.editedItem.vendor.installmentsNumber) * parseInt(this.editedItem.vendor.creditPriceMonth);
    },
    checkFormData() {
      this.editedItem.customer.home.residencePost = this.editedItem.customer.home.residencePost.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceCity = this.editedItem.customer.home.residenceCity.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceArea = this.editedItem.customer.home.residenceArea.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.residenceAddress = this.editedItem.customer.home.residenceAddress.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')

      this.editedItem.customer.home.homePost = this.editedItem.customer.home.homePost.replace(/(\D)|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeCity = this.editedItem.customer.home.homeCity.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeArea = this.editedItem.customer.home.homeArea.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')
      this.editedItem.customer.home.homeAddress1 = this.editedItem.customer.home.homeAddress1.replace(/[ ]|([\r\n])|(<\/?. ?>)/g,'')

      if (this.editedItem.header.caseType !== '' || this.editedItem.header.caseType4 !== '') {
        if (this.editedItem.header.type[1].value === true) {
          this.showMessageDialog('錯誤', '請確認專案類型！', true, () => {
          }, () => {
          });
          return false;
        }
      }

      var pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,6})$/;
      if(this.editedItem.customer.email !== '' &&
        !pattern.test(this.editedItem.customer.email)) {
        this.showMessageDialog('錯誤', '請填寫正確的Email！', true, () => {
        }, () => {
        });
        return false;
      }

      if (this.editedItem.customer.memberId === '') {
        this.showMessageDialog('錯誤', '請填寫身分證！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.birthday === '') {
        this.showMessageDialog('錯誤', '請填寫生日！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.memberIdDate === '') {
        this.showMessageDialog('錯誤', '請填寫身分證初補換日！', true, () => {
        }, () => {
        });
        return false;
      }
      if (!this.editedItem.customer.memberIdType[0].value && !this.editedItem.customer.memberIdType[1].value && !this.editedItem.customer.memberIdType[2].value ) {
        this.showMessageDialog('錯誤', '請勾選身分證初補換！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.memberIdCity === '' || this.editedItem.customer.memberIdCity <= 0) {
        this.showMessageDialog('錯誤', '請填寫發證地點！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.cellphone === '') {
        this.showMessageDialog('錯誤', '請填寫行動電話！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.customer.cellphone.length !== 10) {
        this.showMessageDialog('錯誤', '行動電話需10碼！', true, () => {
        }, () => {
        });
        return false;
      }
      // if (this.editedItem.firstContact.cellphone.length !== 10) {
      //   this.showMessageDialog('錯誤', '聯絡人行動電話需10碼！', true, () => {
      //   }, () => {
      //   });
      //   return false;
      // }
      // if (this.editedItem.secondContact.cellphone.length !== 10) {
      //   this.showMessageDialog('錯誤', '聯絡人行動電話需10碼！', true, () => {
      //   }, () => {
      //   });
      //   return false;
      // }
      if (this.editedItem.company.name === '') {
        this.showMessageDialog('錯誤', '請填寫公司名稱！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.company.phone === '') {
        this.showMessageDialog('錯誤', '請填寫公司電話！', true, () => {
        }, () => {
        });
        return false;
      }
      if (this.editedItem.jointGuarantor.name !== ''){
        let hasCheck = false;
        this.editedItem.hasJointGuarantor.forEach(item=>{
          if (item.value === true){
            hasCheck = true;
          }
        });
        if (!hasCheck){
          this.showMessageDialog('錯誤', '請勾選保證人的選項！', true, () => {
          }, () => {
          });
          return false;
        }
      }

      return true;
    },
    save() {
      console.log(`save === ${JSON.stringify(this.editedItem)}`);
      if (this.checkFormData()) {
        if (this.isStaff){
          this.changeInstallmentsNumber(); // 上傳前再算一次總額
        }

        this.editedItem.customer.memberId = this.editedItem.customer.memberId.toUpperCase();
        this.editedItem.platform = 0;
        this.$emit('saveData', this.editedItem);
      }
    },
    onFinishUpload(result) {
      console.log(`onFinishUpload === ${JSON.stringify(result)}`);
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    dataURLtoBlob(dataUrl) {
      let arr = dataUrl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    showTip(){
      if (this.firstTipCount < 1) {
        this.firstTipCount += 1;
        this.showMessageDialog('提示','聯絡人一率保密，僅在逾期繳款才會通知聯絡人', true , ()=>{}, ()=>{});
        setTimeout(()=>{
          this.messageDialog.visible = false;
        }, 2500);
      }
    },
    showSecondTip(){
      if (this.secondTipCount < 1) {
        this.secondTipCount += 1;
        this.showMessageDialog('提示','聯絡人一率保密，僅在逾期繳款才會通知聯絡人', true , ()=>{}, ()=>{});
        setTimeout(()=>{
          this.messageDialog.visible = false;
        }, 2500);
      }
    },
    changeResidenceInfo(){
      this.editedItem.customer.home.residenceCity = this.editedItem.customer.home.residenceCity.replace(/[ ]|[\r\n]|<\/?. ?>/g,'')
      this.editedItem.customer.home.residenceArea = this.editedItem.customer.home.residenceArea.replace(/[ ]|[\r\n]|<\/?. ?>/g,'')
      if(this.editedItem.customer.home.residenceCity !== "" && this.editedItem.customer.home.residenceArea) {
        const city = this.editedItem.customer.home.residenceCity;
        const area = this.editedItem.customer.home.residenceArea
        const tempList = this.areaList[city]
        const areaArray = tempList.filter(m => m.text === area);
        if(areaArray.length > 0) {
          const areaInfo = areaArray[0]
          this.editedItem.customer.home.residencePost = areaInfo.zip
        }
      }
    },
    changeHomeInfo() {
      this.editedItem.customer.home.homeCity = this.editedItem.customer.home.homeCity.replace(/[ ]|[\r\n]|<\/?. ?>/g,'')
      this.editedItem.customer.home.homeArea = this.editedItem.customer.home.homeArea.replace(/[ ]|[\r\n]|<\/?. ?>/g,'')
      if(this.editedItem.customer.home.homeCity !== "" && this.editedItem.customer.home.homeArea) {
        const city = this.editedItem.customer.home.homeCity;
        const area = this.editedItem.customer.home.homeArea
        const tempList = this.areaList[city]
        const areaArray = tempList.filter(m => m.text === area);
        if(areaArray.length > 0) {
          const areaInfo = areaArray[0]
          this.editedItem.customer.home.homePost = areaInfo.zip
        }
      }
    },
    changeDateInfo(key) {
      if (key === 'birthday') {
        const dateArray = this.editedItem.customer.birthday.split('/');
        if(dateArray.length === 3) {
          if(dateArray[0] !== '' && dateArray[1] !== '' && dateArray[2] !== '') {
            this.editedItem.customer.birthdayInfo.year = dateArray[0];
            this.editedItem.customer.birthdayInfo.month = dateArray[1];
            this.editedItem.customer.birthdayInfo.day = dateArray[2];
            this.editedItem.customer.birthday = `${this.editedItem.customer.birthdayInfo.year}年${this.editedItem.customer.birthdayInfo.month}月${this.editedItem.customer.birthdayInfo.day}日`;
          }
        }
      } else if (key === 'memberIdDate') {
        const dateArray = this.editedItem.customer.memberIdDate.split('/');
        if(dateArray.length === 3) {
          if(dateArray[0] !== '' && dateArray[1] !== '' && dateArray[2] !== '') {
            this.editedItem.customer.memberIdDateInfo.year = dateArray[0];
            this.editedItem.customer.memberIdDateInfo.month = dateArray[1];
            this.editedItem.customer.memberIdDateInfo.day = dateArray[2];
            this.editedItem.customer.memberIdDate = `${this.editedItem.customer.memberIdDateInfo.year}年${this.editedItem.customer.memberIdDateInfo.month}月${this.editedItem.customer.memberIdDateInfo.day}日`;
          }
        }
      } else if (key === 'jointGuarantor.birthday') {
        const dateArray = this.editedItem.jointGuarantor.birthday.split('/');
        if(dateArray.length === 3) {
          if(dateArray[0] !== '' && dateArray[1] !== '' && dateArray[2] !== '') {
            this.editedItem.jointGuarantor.birthdayInfo.year = dateArray[0];
            this.editedItem.jointGuarantor.birthdayInfo.month = dateArray[1];
            this.editedItem.jointGuarantor.birthdayInfo.day = dateArray[2];
            this.editedItem.jointGuarantor.birthday = `${this.editedItem.jointGuarantor.birthdayInfo.year}年${this.editedItem.jointGuarantor.birthdayInfo.month}月${this.editedItem.jointGuarantor.birthdayInfo.day}日`;
          }
        }
      } else if (key === 'jointGuarantor.memberIdDate') {
        const dateArray = this.editedItem.jointGuarantor.memberIdDate.split('/');
        if(dateArray.length === 3) {
          if(dateArray[0] !== '' && dateArray[1] !== '' && dateArray[2] !== '') {
            this.editedItem.jointGuarantor.memberIdDateInfo.year = dateArray[0];
            this.editedItem.jointGuarantor.memberIdDateInfo.month = dateArray[1];
            this.editedItem.jointGuarantor.memberIdDateInfo.day = dateArray[2];
            this.editedItem.jointGuarantor.memberIdDate = `${this.editedItem.jointGuarantor.memberIdDateInfo.year}年${this.editedItem.jointGuarantor.memberIdDateInfo.month}月${this.editedItem.jointGuarantor.memberIdDateInfo.day}日`;
          }
        }
      }
    },
  },
};
</script>

<style scoped src="../../assets/css/installment_product_view.css">

</style>

<style scoped>
.photo_page_wrapper .layout { padding:10px; margin:30px auto; }
.photo_page_wrapper .layout .box { padding:15px; margin:-5px; }
.photo_page_wrapper .layout .box img { max-width:100%; max-height:100%; }
</style>



// WEBPACK FOOTER //
// src/pages/web/EditInstallmentProductView.vue